import { handleVersionMismatch } from 'actions/versionSync';
import { FETCH_MYSELF_ERROR, FETCH_MYSELF_REQUESTED, FETCH_MYSELF_SUCCESS, } from 'actiontypes/myself';
import { VersionMismatch } from 'services/BaseService';
import MyselfService from 'services/MyselfService';
import { IFetchMyselfResponseData, IMyselfService } from 'types/myself';

export default fetchMyself(new MyselfService());

export function fetchMyself(service: IMyselfService) {
  return (setIsFetching = false) => async (dispatch: Function) => {
    if (setIsFetching) {
      dispatch(fetchMyselfRequested());
    }
    try {
      const { data } = await service.fetchMyself();

      dispatch(fetchMyselfSuccess(data));
      return data;
    } catch (error) {
      if (error instanceof VersionMismatch) {
        dispatch(handleVersionMismatch(error));
      }
      console.error(error);
      dispatch(fetchMyselfError(error));
      throw error;
    }
  };
}

export const fetchMyselfRequested = () => ({ type: FETCH_MYSELF_REQUESTED });

export const fetchMyselfSuccess = (data: IFetchMyselfResponseData)  => ({ type: FETCH_MYSELF_SUCCESS, payload: data });

export const fetchMyselfError = (error: any) => ({ error, type: FETCH_MYSELF_ERROR });